"use strict";

exports.__esModule = true;
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _icon = _interopRequireDefault(require("./../../../../fonts/icon"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
class PasswordInput extends _react.default.Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "revealOrHidePassword", () => {
      let newInputType = document.getElementById(this.props.id).type === 'password' ? 'text' : 'password';
      document.getElementById(this.props.id).type = newInputType;
      if (newInputType === 'text') {
        document.getElementById('btn-eye-' + this.props.id).classList.add('reveal');
      } else {
        document.getElementById('btn-eye-' + this.props.id).classList.remove('reveal');
      }
    });
  }
  render() {
    const {
      id,
      type,
      name,
      value,
      required,
      onChange
    } = this.props;
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "input-group"
    }, /*#__PURE__*/_react.default.createElement("input", {
      id: id,
      type: type,
      name: name,
      className: 'form-control passwordWithHideIcon',
      value: value,
      required: required,
      onChange: onChange
    }), /*#__PURE__*/_react.default.createElement("button", {
      className: "btn-eye d-flex align-items-center",
      id: 'btn-eye-' + id,
      type: "button",
      onClick: this.revealOrHidePassword
    }, /*#__PURE__*/_react.default.createElement(_icon.default, {
      icon: "remove_red_eye",
      size: 16
    })));
  }
}
exports.default = PasswordInput;
module.exports = exports.default;